import { apiClient } from 'pobble-components/dist/api'

const apiGetUserSchool = params => apiClient.get('v3/me', { params })

const apiUpdateSchoolDetails = (id, data, params) =>
  apiClient.put(`v3/schools/${id}`, data, { params })

const apiUploadAvatar = (id, img) => {
  const formData = new FormData()
  formData.append('logo', img)
  return apiClient.post(`v3/schools/${id}/logos`, formData)
}

const apiRemoveAvatar = id => apiClient.delete(`v3/schools/${id}/logos`)

const apiUploadCover = (id, img) => {
  const formData = new FormData()
  formData.append('background_image', img)
  return apiClient.post(`v3/schools/${id}/background_images`, formData)
}

const apiRemoveCover = id =>
  apiClient.delete(`v3/schools/${id}/background_images`)

const apiGetSchoolTeam = (schoolId, params) =>
  apiClient.get(`v3/schools/${schoolId}`, {
    params: {
      include:
        'school.paid,school.teacher_types,school.teacher_type.status,school.teacher_type.account.names,school.teacher_type.account.email_identity,school.teacher_type.account.email_identity.details,school.teacher_type.account.subscriptions,school.teacher_type.account.email_identity.email,school.teacher_type.account.avatar,school.pending_teacher_types,school.pending_teacher_type.names,school.pending_teacher_type.account.email_identity.email,school.pending_teacher_type.account.names,school.pending_teacher_type.account.email_identity.email,school.pending_teacher_type.account.avatar,school.teacher_type.account.signin_details'
    }
  })

const apiDeleteTeacher = (schoolId, teacherId) =>
  apiClient.delete(`v3/schools/${schoolId}/teachers/${teacherId}`)

const apiPromoteTeacher = id =>
  apiClient.put(`v3/teachers/${id}/promote_to_school_leader`)

const apiDemoteTeacher = id =>
  apiClient.put(`v3/teachers/${id}/demote_from_school_leader`)

const apiAddTeacher = (id, email) =>
  apiClient.post(
    `v3/schools/${id}/teachers?include=account.names,account.teacher_type.status`,
    { email }
  )

const apiApprovePendingTeacher = id =>
  apiClient.put(`v3/pending_teachers/${id}/approve`)
const apiDeclinePendingTeacher = id =>
  apiClient.put(`v3/pending_teachers/${id}/decline`)

const apiResendInvitation = id =>
  apiClient.post(`v3/teachers/${id}/resend_invitation_email`)

const apiGetGroupSubCheckoutUrl = id =>
  apiClient.get(`v3/subscriptions_groups/${id}/chargebee_self_serve_portal_url`)

const apiAddGroupSubToUser = (groupSubId, userId) =>
  apiClient.post(
    `v3/subscriptions_groups/${groupSubId}/assign_subscriptions_group_addon?account_id=${userId}&addon_type=pobble-silver`,
    {
      params: {
        include: 'account.subscriptions'
      }
    }
  )

const apiRemoveGroupSubFromUser = (groupSubId, addonId) =>
  apiClient.post(
    `v3/subscriptions_groups/${groupSubId}/unassign_subscriptions_group_addon?addon_id=${addonId}`,
    {
      params: {
        include: 'account.subscriptions'
      }
    }
  )

export {
  apiGetUserSchool,
  apiUpdateSchoolDetails,
  apiUploadAvatar,
  apiRemoveAvatar,
  apiUploadCover,
  apiRemoveCover,
  apiGetSchoolTeam,
  apiDeleteTeacher,
  apiPromoteTeacher,
  apiDemoteTeacher,
  apiAddTeacher,
  apiApprovePendingTeacher,
  apiDeclinePendingTeacher,
  apiResendInvitation,
  apiGetGroupSubCheckoutUrl,
  apiAddGroupSubToUser,
  apiRemoveGroupSubFromUser
}
